import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { GearRequest } from '../models/gearrequest.model';
import { ErrorService } from './error.service';
import { AuthService } from './auth.service';
import { GearRequestSearchResultModel } from '../models/gear-request-search-result.model';
import { GetAllGearRequestModel } from '../models/get-all-gear-request.model';

@Injectable({ providedIn: 'root' })
export class GearRequestService extends BaseService {

  baseUrl: string;
  constructor(
    public httpClient: HttpClient,
    public errorService: ErrorService,
    public authService: AuthService
  )
  {
    super('api/GearRequest/', httpClient, errorService, authService);
  }
  
  //saveGearRequest
  saveGearRequest(action: string, gearrequestObj: GearRequest): Observable<any>
  {
    return this.postRequest(action, JSON.stringify(gearrequestObj));
  }

  searchGearRequest(action: string, crew: number = 0, ReplaceOrRepair: number = 0, LastName: string = null, GearType: number = 0,
    startDate: Date = null, endDate: Date = null, pageNumber: number = 0, pageSize: number = 10, isReport: boolean): Observable<any> {

    let params = new HttpParams()
      .set('crew', crew.toString())
      .set('replaceOrRepair', ReplaceOrRepair.toString())
      .set('lastName', LastName.toString())
      .set('gearType', GearType.toString())
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString())
      .set('isReport', String(isReport))

    if (startDate != null) {
      params = params.set('startDate', startDate.toDateString());
    }
    if (endDate != null) {
      params = params.set('endDate', endDate.toDateString());
    }
    console.log(params);
    return this.customGetRequestWithQueryString<GetAllGearRequestModel>(action, params);
  }

  getGearRequestData(action: string, gearrequestid: number): Observable<any> {
    const params = new HttpParams()
      .set('gearrequestid', gearrequestid.toString());
    return this.customGetRequestWithQueryString<GearRequest>(action, params);
  }

  deleteGearRequest(action: string, gearrequestid: number): Observable<any> {
    return this.deleteRequest(gearrequestid);
  }
  updateGearRequest(action: string, gearData: GearRequest): Observable<any> {
    return this.postRequest(action, JSON.stringify(gearData));
  }
}
